import { render, staticRenderFns } from "./StudentExamCard.vue?vue&type=template&id=4a6c1d2c&"
import script from "./StudentExamCard.vue?vue&type=script&lang=js&"
export * from "./StudentExamCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports